export default "__VITE_ASSET__I0LFc8vU__"